<template>
  <div id="app">
    <router-view />
    <toast-host />
  </div>
</template>

<script>
import ToastHost from '@/components/ToastHost.vue'

export default {
  name: 'App',
  components: { ToastHost }
}
</script>
